import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const LIST_ORGANIZATIONS_FAIL = "ORGANIZATION:LIST_ORGANIZATIONS_FAIL";

export interface ListOrganizationsFailAction extends Action {
  type: typeof LIST_ORGANIZATIONS_FAIL;
  organization: OrganizationKeyName;
}

export const listOrganizationsFailAction = (
  organization: OrganizationKeyName
): ListOrganizationsFailAction => ({
  type: LIST_ORGANIZATIONS_FAIL,
  organization,
});
